import { type AnalyticsPlacementTypes } from '@core/analytics'
import { useIsHydrating } from '@muse-web/router'
import type { TButtonSize } from '@ds/components'

import { FollowButton } from '../components/follow-button'
import { useFollowAction } from '../hooks/useFollowAction'

export type TFollowButtonContainerProps = {
    as?: 'button' | 'action'
    username: string
    creatorUserId: string
    placement: AnalyticsPlacementTypes
    hideMobileText?: boolean
    size?: TButtonSize
    showOnlySecondaryVariant?: boolean
    showForOwnProfile?: boolean
    onUnfollow?: (dateUnfollowed: number) => void
}

/** Wires the pure FollowButton over {@link useFollowAction}. Renders nothing on your own profile. */
export const FollowButtonContainer = ({
    as,
    username,
    creatorUserId,
    placement,
    hideMobileText,
    size,
    showOnlySecondaryVariant,
    showForOwnProfile = false,
    onUnfollow,
}: TFollowButtonContainerProps) => {
    const isHydrating = useIsHydrating()
    const { isOwnProfile, isFollowing, loading, label, toggle } = useFollowAction({
        username,
        creatorUserId,
        placement,
        onUnfollow,
    })

    const isBusy = loading && !isHydrating

    if (isOwnProfile && !showForOwnProfile) {
        return null
    }

    return (
        <FollowButton
            as={as}
            label={label}
            isFollowing={isFollowing}
            loading={isBusy}
            disabled={isBusy}
            hideMobileText={hideMobileText}
            size={size}
            showOnlySecondaryVariant={showOnlySecondaryVariant}
            onClick={toggle}
        />
    )
}
